import { SiteShell } from '@/components/layout/SiteShell';
import { resolvePage } from '@/lib/paths';
import { ThemeProvider } from '@/lib/theme';
import { Router, useRouter } from '@/lib/router';
import { HomePage } from '@/pages/HomePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { TopicPage } from '@/pages/TopicPage';

function Routes() {
  const { path } = useRouter();
  const page = resolvePage(path);

  if (page.kind === 'home') {
    return <HomePage />;
  }

  if (page.kind === 'topic') {
    return <TopicPage topic={page.topic} project={page.project} />;
  }

  return <NotFoundPage />;
}

type AppProps = {
  url: string;
};

export function App({ url }: AppProps) {
  return (
    <Router initialPath={url}>
      <ThemeProvider>
        <SiteShell>
          <Routes />
        </SiteShell>
      </ThemeProvider>
    </Router>
  );
}

export default App;
